/**
 * @fileoverview Agent definition for auto-gather.
 *
 * This agent intelligently selects a thematically coherent batch of findings
 * and weaknesses for a refine session. It analyzes available critique data
 * and groups related issues that can be meaningfully addressed together.
 *
 * @category narrative.prose.revision
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'auto-gather',
  kind: 'primitive',
  name: 'Auto Gather',
  description: 'Intelligently selects a thematically coherent batch of findings and weaknesses for refinement.',
  category: 'writing',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.prose.revision',
    usedBy: [
      'use-auto-gather.ts',
    ],
    usedInComposites: [],
    relatedAgents: [
      'critique-prose-flow',
      'critique-sensory-atmosphere',
      'critique-voice-emotion',
      'draft-refiner-v2',
    ],
  },
};
